import type { DecisionQuestionInput, FieldDef, PlaybookInput, TaskTemplateInput } from '@takeit4me/shared'

/** Builders shared by the industry packs (packs.ts, packsMore.ts): the defaults every pack entry starts from. */
export const ALL_CHANNELS = ['email', 'sms', 'chat', 'voice'] as const

export const pq = (x: Omit<DecisionQuestionInput, 'layer' | 'locked' | 'enabled' | 'unsure_low' | 'unsure_high' | 'rules' | 'applies_to' | 'threshold'> & Partial<DecisionQuestionInput>): DecisionQuestionInput =>
  ({ layer: 'pack', locked: false, enabled: true, unsure_low: 0.45, unsure_high: 0.75, threshold: 0.6, rules: [], applies_to: [...ALL_CHANNELS], ...x })

export const pb = (x: Partial<PlaybookInput> & Pick<PlaybookInput, 'key' | 'name' | 'goal'>): PlaybookInput =>
  ({ layer: 'pack', steps: [], actions: [], handover: [], channel_notes: {}, approved_wording: {}, examples: [], ...x })

export const tt = (x: Partial<TaskTemplateInput> & Pick<TaskTemplateInput, 'key' | 'name' | 'kind'>): TaskTemplateInput => ({
  description: '', required_info: [], systems: { repos: [], network: [], crm_objects: [], actions: [] }, risk: 'low', default_route: 'ai_signoff',
  acceptance: [], gate: 'customer_preview', price_credits: 0, budget: { minutes: 30, cost_micros: 2_000_000, max_files: 20 }, examples: [], ...x,
})

/** A pack field: indexed, personal data and AI-writable are off unless said. */
export const fd = (key: string, label: string, type: FieldDef['type'], o: Partial<FieldDef> = {}): FieldDef =>
  ({ key, label, type, required: false, indexed: false, pii: false, ai_writable: false, ...o })
